import { useState } from 'react'
import { Grid } from '@mui/material'

import Button from '../components/Button'
import InputField from '../components/InputField'
import GridHeader from '../components/GridHeader'
import GeneralDocs from '../components/GeneralDocs'
import GeneralInfo from '../components/GeneralInfo'
import { config, configs } from '../settings/configs'
import { titlesImpostazioni, phrasesImpostazioni } from '../settings/settings'
import { ORGANIZATION } from '../hooks/env-variables'
import { useAuth } from '../hooks/auth-hook'
import { useFeedback } from '../hooks/feedback-hook'
import { useResetPasswordRequestMutation } from '../hooks/api-slice'

const Home = () => {
  const [codiceUtente, setCodiceUtente] = useState()
  const [password, setPassword] = useState()
  const [loading, setLoading] = useState()

  const [showForgotPassword, setShowForgotPassword] = useState()
  const [recoveryCodice, setRecoveryCodice] = useState()
  const [loadingR, setLoadingR] = useState()

  const { login } = useAuth()
  const { setFeedback } = useFeedback()
  const [resetPasswordRequest] = useResetPasswordRequestMutation()

  const triggerRequest = async () => {
    setLoadingR(true)
    const result = await resetPasswordRequest({ codiceUtente: recoveryCodice })
    setLoadingR()

    if (result?.error) {
      setFeedback(
        result?.error?.data?.message,
        true,
        titlesImpostazioni.titleResetPassword,
      )
      return
    }

    setFeedback(
      phrasesImpostazioni.phraseResetPasswordRequest,
      false,
      titlesImpostazioni.titleResetPassword,
    )
    setShowForgotPassword()
    setRecoveryCodice()
  }

  document.title = `${config?.name} - Home`

  const oConfigs = Object.entries(configs)?.filter(([o]) => o !== ORGANIZATION)

  const MyLink = ({ link, label }) => (
    <a
      target='_blank'
      rel='noopener noreferrer'
      href={link}
      style={{ textDecoration: 'none', margin: '0 8px' }}
    >
      {label || link}
    </a>
  )

  const MySpan = () => <span style={{ margin: '0 4px' }}>|</span>

  const GridLinks = () => (
    <Grid
      size={12}
      marginTop={3}
      style={{ textAlign: 'center', fontSize: '0.7rem' }}
    >
      <MyLink link={config?.website} label={`Sito ${config?.name}`} />
      <MySpan />
      {oConfigs?.map(([o, oConfig], index) => (
        <span key={o}>
          {index > 0 && <MySpan />}
          <MyLink
            link={oConfig?.piattaforma || oConfig?.website}
            label={`Piattaforma ${oConfig?.name}`}
          />
        </span>
      ))}
    </Grid>
  )

  return (
    <Grid
      container
      marginY={2}
      direction='column'
      justifyContent='space-between'
      sx={{ width: '100%', minHeight: '85vh' }}
    >
      <GeneralInfo />
      <Grid container sx={{ width: '100%' }}>
        <Grid container sx={{ width: '100%' }}>
          <form
            style={{ width: '100%' }}
            onSubmit={async e => {
              e.preventDefault() // prevents page reload
              setLoading(true)
              await login({ codice: codiceUtente, password })
              setLoading()
            }}
          >
            <Grid
              container
              spacing={1}
              direction='column'
              alignItems='center'
              sx={{ width: '100%' }}
            >
              <GridHeader h2 text='Login' />
              <Grid size={{ xs: 8, md: 4 }}>
                <InputField
                  id='codice'
                  value={codiceUtente}
                  onChange={setCodiceUtente}
                  label='Codice utente'
                  autoFocus
                />
              </Grid>
              <Grid size={{ xs: 8, md: 4 }}>
                <InputField
                  id='password'
                  value={password}
                  onChange={setPassword}
                  label='Password'
                  type='password'
                />
              </Grid>
              <Button
                type='submit'
                loading={loading}
                disabled={!codiceUtente || !password}
              >
                Vai
              </Button>
            </Grid>
          </form>
        </Grid>
        <Grid
          container
          margin={3}
          spacing={1}
          direction='column'
          alignItems='center'
          sx={{ width: '100%' }}
        >
          <Grid
            size='auto'
            style={{
              cursor: 'pointer',
              fontSize: '0.8rem',
              textAlign: 'center',
              textDecoration: 'underline',
            }}
            onClick={() => setShowForgotPassword(!showForgotPassword)}
          >
            Password dimenticata?
          </Grid>
          {showForgotPassword && (
            <>
              <Grid size={{ xs: 8, md: 4 }}>
                <InputField
                  id='codice'
                  value={recoveryCodice}
                  onChange={setRecoveryCodice}
                  label='Codice utente'
                />
              </Grid>
              <Button
                light
                loading={loadingR}
                disabled={!recoveryCodice}
                onClick={triggerRequest}
              >
                Reset password
              </Button>
            </>
          )}
        </Grid>
      </Grid>
      <GeneralDocs />
      <GridLinks />
    </Grid>
  )
}

export default Home
